module.exports = "/_next/static/images/calculator-line-4fd169b0776fc979049e0dd4c4e028d7.svg";